export default "__VITE_ASSET__lMMAnseb__"